// Encode / decode the calculator state to URL search params for shareable scenarios.
const KEYS = [
  "method",
  "current_age",
  "retirement_age",
  "career_start_age",
  "education_years",
  "monthly_gross_salary",
  "past_salary_growth",
  "future_salary_growth",
  "tax_class",
  "children",
];

export const stateToParams = (data) => {
  const params = new URLSearchParams();
  KEYS.forEach((k) => {
    const v = data[k];
    if (v !== undefined && v !== null && v !== "") params.set(k, String(v));
  });
  return params.toString();
};

export const paramsToState = (search, fallback) => {
  const p = new URLSearchParams(search);
  if ([...p.keys()].length === 0) return fallback;
  const out = { ...fallback };
  KEYS.forEach((k) => {
    if (p.has(k)) {
      const raw = p.get(k);
      if (k === "method" || k === "tax_class") out[k] = raw;
      else out[k] = raw; // keep as string; CalculatorPage's toNum() handles coercion
    }
  });
  return out;
};

export const buildShareUrl = (data) => {
  const base = window.location.origin + window.location.pathname;
  return `${base}?${stateToParams(data)}`;
};
